import { render, staticRenderFns } from "./mainList.vue?vue&type=template&id=74bd41b5"
import script from "./mainList.vue?vue&type=script&lang=js"
export * from "./mainList.vue?vue&type=script&lang=js"
import style0 from "./mainList.vue?vue&type=style&index=0&id=74bd41b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports